import { createQueryKeys } from "@lukemorales/query-key-factory"

import API from "../../index"
import {
  GetCampaignRequestParams,
  GetCampaignsRequestParams,
  GetTemporaryCampaignRequestParams,
} from "./campaign.types"
import { GUIDELINE_RULE_DTO_ENUMS } from "../guidelineRules/guidelineRules.constants"
import { BrandDto } from "../brand/brand.types"
import { BRAND_DTO_ENUMS } from "../brand/brand.constants"
import BRAND from "constants/brand"
import { LOCALES } from "constants/locales"

export const CAMPAIGN_DTO_ENUMS = {
  OUTPUT_TYPE_FL: {
    /** 사진 */
    PHOTO: `${GUIDELINE_RULE_DTO_ENUMS.OUTPUT_TYPE.PHOTO},0`,
    /** 영상 */
    VIDEO: `0,${GUIDELINE_RULE_DTO_ENUMS.OUTPUT_TYPE.VIDEO}`,
  },
}

export const GET_CAMPAIGNS_DTO_ENUMS = {
  MODE: {
    PRODUCT_HIERARCHY: "PRODUCT_HIERARCHY",
  },
  ORDER: {
    /** 생성일 */
    CREATED_AT: "CREATED_AT",
  },
} as const

export const campaignQueryKeys = createQueryKeys("campaign", {
  getCampaign: (params: GetCampaignRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Campaign.getCampaign(params),
  }),
  getCampaigns: (params: GetCampaignsRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Campaign.getCampaigns(params),
  }),
  getTemporaryCampaign: (params: GetTemporaryCampaignRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Campaign.getTemporaryCampaign(params),
  }),
})

export const getCampaignCommissionOptions = (
  brand:Pick<BrandDto, 'currency' | 'destinationCountry'>,
) => {
  const brandCurrencyMultiplier = brand.currency === BRAND_DTO_ENUMS.CURRENCY.KRW ? 10 : 1
  const appCurrencyMultiplier = process.env.LOCALE === LOCALES.KO ? 10 : 1
  const additionalCommission = BRAND.isJapanBrandInKorea(brand) ? 2000 : 0
  const COMMISSIONS = [20000, 30000, 40000, 50000]
  const COMMISSION_REFERENCE_URL_MAP = {
    20000: "https://glovv.co.kr/redirect/reference/2",
    30000: "https://glovv.co.kr/redirect/reference",
    40000: "https://glovv.co.kr/redirect/reference",
    50000: null,
  }
  return COMMISSIONS.map((commission, idx) => {
    return {
      commission: commission * appCurrencyMultiplier, // campaign.commission_amount - 앱에 보이는 값
      commissionPrice: (commission + additionalCommission) * brandCurrencyMultiplier, // 원고료 결제금액
      maxStep: 2,
      isStepSelectable: ![0].includes(idx),
      referenceUrl: COMMISSION_REFERENCE_URL_MAP[commission],
      metaData: {
        brandCurrency: brand.currency,
      }
    }
  })
}